module.exports = __webpack_public_path__ + "img/case-icon1.aa2963ce.jpg";